var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1668 18.8333H5.8335C5.49183 18.8333 5.2085 18.55 5.2085 18.2083C5.2085 17.8667 5.49183 17.5833 5.8335 17.5833H14.1668C14.5085 17.5833 14.7918 17.8667 14.7918 18.2083C14.7918 18.55 14.5085 18.8333 14.1668 18.8333Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9585 5.10001L13.6252 7.48335C13.1835 7.80001 12.5502 7.60835 12.3585 7.10001L10.7835 2.90001C10.5168 2.17501 9.49185 2.17501 9.22518 2.90001L7.64185 7.09168C7.45018 7.60835 6.82518 7.80001 6.38352 7.47501L3.05018 5.09168C2.38352 4.62501 1.50018 5.28335 1.77518 6.05835L5.24185 15.7667C5.35852 16.1 5.67518 16.3167 6.02518 16.3167H13.9669C14.3169 16.3167 14.6335 16.0917 14.7502 15.7667L18.2169 6.05835C18.5002 5.28335 17.6169 4.62501 16.9585 5.10001ZM12.0835 12.7917H7.91685C7.57518 12.7917 7.29185 12.5083 7.29185 12.1667C7.29185 11.825 7.57518 11.5417 7.91685 11.5417H12.0835C12.4252 11.5417 12.7085 11.825 12.7085 12.1667C12.7085 12.5083 12.4252 12.7917 12.0835 12.7917Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrown);
export default __webpack_public_path__ + "static/media/crown.f04a4a7d71bf40db420e74cf7bb4bfdc.svg";
export { ForwardRef as ReactComponent };